import { call, put, takeLatest } from 'redux-saga/effects';
import { Apis } from 'src/services/api';
import { addTaskAsync, deleteTaskAsync, getTasksAsync, updateTaskAsync } from './actions';

function* getTasks(api, action) {
  try {
    const response = yield call(api, action.payload);
    if (response?.ok) {
      const data = response.data ?? { tasks: [], total: 0 };
      yield put(getTasksAsync.success(data));
    } else yield put(getTasksAsync.failure(response));
  } catch (err) {
    yield put(getTasksAsync.failure(err));
  }
}

function* updateTask(api, action) {
  try {
    const response = yield call(api, action.payload);
    if (response?.ok) {
      const data = response.data ?? { tasks: [], total: 0 };
      yield put(updateTaskAsync.success(data));
    } else yield put(updateTaskAsync.failure(response));
  } catch (err) {
    yield put(updateTaskAsync.failure(err));
  }
}

function* addTask(api, action) {
  try {
    const response = yield call(api, action.payload);
    if (response?.ok) {
      const data = response.data ?? { tasks: [], total: 0 };
      yield put(addTaskAsync.success(data));
    } else yield put(addTaskAsync.failure(response));
  } catch (err) {
    yield put(addTaskAsync.failure(err));
  }
}

function* deleteTask(api, action) {
  try {
    const response = yield call(api, action.payload);
    if (response?.ok) yield put(deleteTaskAsync.success({}));
    else yield put(deleteTaskAsync.failure(response));
  } catch (err) {
    yield put(deleteTaskAsync.failure(err));
  }
}

export default function tasksSaga(apiInstance: Apis) {
  return [
    takeLatest(getTasksAsync.request, getTasks, apiInstance.getTasks),
    takeLatest(updateTaskAsync.request, updateTask, apiInstance.updateTask),
    takeLatest(addTaskAsync.request, addTask, apiInstance.addTask),
    takeLatest(deleteTaskAsync.request, deleteTask, apiInstance.deleteTask),
  ];
}
